module.exports = __webpack_public_path__ + "images/airtm@2x.551b9ab4c5e55f9ff82ad22d15863597.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/airtm@2x.png
// module id = 1013
// module chunks = 0